/**
 * Typed Redux Hooks
 * Pre-typed versions of useDispatch and useSelector for better TypeScript support
 * and to avoid importing store types everywhere
 */

import { useDispatch, useSelector } from 'react-redux';

/**
 * Typed useDispatch hook
 * Use throughout the app instead of plain `useDispatch`
 */
export const useAppDispatch = () => useDispatch();

/**
 * Typed useSelector hook
 * Use throughout the app instead of plain `useSelector`
 */
export const useAppSelector = useSelector;

// Re-export for convenience
export { useDispatch, useSelector };
